// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `order-summary table.table td{padding-left:15px;padding-right:15px}
`, "",{"version":3,"sources":["webpack://./ticket/order-summary.vue"],"names":[],"mappings":"AACA,6BACC,iBAAA,CACA,kBAAA","sourcesContent":["\norder-summary table.table td {\n\tpadding-left: 15px;\n\tpadding-right: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
